<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}
  @if (!showFormLoader) {
<div>
    <div class="compare-container">
      <div class="compare-pane">
        <h4>Before</h4>
        <table class="table table-bordered custom-table">
          <thead>
            <tr><th>Field</th><th>Value</th></tr>
          </thead>
          <tbody>
            @for (row of beforeRows; track $index) {
<tr>
              <td>{{ row.key }}</td>
              <td>{{ row.value }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
      <div class="compare-pane">
        <h4>After</h4>
        <table class="table table-bordered custom-table">
          <thead>
            <tr><th>Field</th><th>Value</th></tr>
          </thead>
          <tbody>
            @for (row of afterRows; track $index) {
<tr>
              <td>{{ row.key }}</td>
              <td>{{ row.value }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
